/**
 * Canonical "what does this membership give the customer" headline, derived from
 * the stored benefit-engine fields. Shared by the creator preview and the tiers
 * list so the merchant sees the exact same language everywhere (and matching the
 * mobile offering card). Returns null for PERKS_ONLY / unknown so callers can
 * fall back to the perks list.
 */
export type BenefitHeadlineInput = {
  benefitType?: string | null;
  discountPercent?: number | null;
  discountFlatPaise?: number | null;
  includedVisits?: number | null;
};

export const benefitHeadlineFromFields = (b: BenefitHeadlineInput): string | null => {
  switch (b.benefitType) {
    case 'DISCOUNT':
      if (b.discountFlatPaise && b.discountFlatPaise > 0) {
        return `₹${Math.round(b.discountFlatPaise / 100).toLocaleString('en-IN')} OFF every visit`;
      }
      if (b.discountPercent && b.discountPercent > 0) {
        return `${b.discountPercent}% OFF everything`;
      }
      return null;
    case 'VISITS':
      return b.includedVisits && b.includedVisits > 0 ? `${b.includedVisits} sessions included` : null;
    case 'POINTS':
      return 'Earn & redeem points';
    default:
      return null;
  }
};
